<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('notification.templates') }}</span></li>
				</ul>
			</div>
		</div>

		<div id="roles_toolbar" class="toolbar">
			<button @click="createTemplate" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('edit.company.notification.templates') }}</a></li>
				<li><a tabindex="-1">{{ $t('remove.company.notification.templates') }}</a></li>
			</ul>
		</div>

		<NotificationTemplatesModal v-if="isVisibleModal" :company-id="companyId" @close-modal="isVisibleModal = false"/>

	</div>
</template>

<script>
import { Table } from '@/core/support_gui_components/table/table'
import { getLocalizedMessage, removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { USER_CONFIG } from 'actions/user'
import NotificationTemplatesModal from 'components/modal/NotificationTemplatesModal'
import { TemplatesManager } from '@/core/administration/TemplatesManager'

export default {
	name: 'CompanyNotificationTemplates',
	metaInfo () {
		return {
			title: this.$t('notification.templates')
		}
	},
	data () {
	 	return {
			isVisibleModal: false
		}
	},
	components: {
		NotificationTemplatesModal
	},
	props: [
		'admin'
	],
	computed: {
		companyId: function () {
			return !this.admin ? this.$store.getters.getProfile.companyId : null
		}
	},
	mounted () {
		let vm = this

		let tableColumns = [
			{
				'title': 'name',
				'columnName': 'name',
				'attribute': 'name'
			},
			{
				'title': 'global',
				'columnName': 'global_localized',
				'attribute': 'global'
			}
		]

		window.manager = new TemplatesManager()

		this.$store.dispatch(USER_CONFIG, vm.admin ? 'globalCompanyNotificationTemplates.tableState' : 'companyNotificationTemplates.tableState')
			.then((config) => {
				window.table = new Table('companyNotificationTemplates', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						frozen: 'none',
						restoringSupport: true
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								if (!vm.admin) {
									if (item.companyId === null) {
										showMessageAlert('Global templates can be edited only on administration page', 'warning')
										return
									}
								}
								vm.isVisibleModal = true
								manager.init({
									action: 'edit',
									template: item
								})
							},
							2: function (item) {
								if (!vm.admin) {
									if (item.companyId === null) {
										showMessageAlert('Global templates can be deleted only on administration page', 'warning')
										return
									}
								}
								manager.deleteTemplate(item, table)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute)
							}
						}
					},
					function (data) {
						_.each(data, function (value) {
							value.global_localized = getLocalizedMessage(value.companyId === null)
						})
					})
				table.setSavedState(config)
				if (vm.admin) {
					table.setDataSortUrl(window.urlContext + 'templates/sort')
					table.setDataUrl(window.urlContext + 'templates/load')
					table.setDataIDsUrl(window.urlContext + 'templates/ids')
				} else {
					table.setDataUrl(window.urlContext + 'company/' + vm.companyId + '/templates/load')
					table.setDataIDsUrl(window.urlContext + 'company/' + vm.companyId + '/templates/ids')
					table.setDataSortUrl(window.urlContext + 'company/' + vm.companyId + '/templates/sort')
				}
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG GroupsTable', error)
			})
	},
	methods: {
		createTemplate: function () {
			this.isVisibleModal = true
			manager.init({
				action: 'create'
			})
		}
	}
}
</script>

<style scoped>

</style>
